import { Navigate, useLocation } from "react-router-dom";

/**
 * Redirect that preserves query string parameters.
 * Used to map legacy paths to their current equivalents.
 *
 * For internal paths (e.g. "/login") uses client-side SPA navigation.
 * For external URLs (http:// or https://) uses a full browser navigation
 * so the browser leaves the SPA entirely.
 */
export default function LegacyAuthRedirect({ to }) {
  const location = useLocation();
  const search = location.search || "";
  const destination = `${to}${search}`;

  if (/^https?:\/\//i.test(to)) {
    window.location.replace(destination);
    return null;
  }

  return <Navigate to={destination} replace />;
}